import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "/sougou" : "http://120.31.134.56:7878", // 设置你的API基础URL
  headers: {
    'Content-Type': 'application/json'
  }
});

const onUpload = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "/sougou" : "http://120.31.134.56:7878",
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
});
export default {
  //新增轮播图
  addCarousel(data, onProgress) {
    return onUpload.post('/carousel/addCarousel', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      onUploadProgress: progressEvent => {
        const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        console.log(`上传进度: ${progress}%`);
        onProgress(progress);
        // 在这里更新显示进度条的代码
      }
    }).then(response => {
      return response.data

    })
      .catch(error => {
        console.error(error);
      });
  },
  //修改轮播图
  alterCarousel(data, onProgress) {
    return onUpload.post('/carousel/alterCarousel', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      onUploadProgress: progressEvent => {
        const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        console.log(`上传进度: ${progress}%`);
        onProgress(progress);
        // 在这里更新显示进度条的代码
      }
    }).then(response => {
      return response.data

    })
      .catch(error => {
        console.error(error);
      });
  },
  //分页查询商铺
  postStoreData(data) {
    return api.post('/store/pageStore', data, {
      headers: {
        'Content-Type': 'application/json'
      } // 将传入的headers对象作为请求的headers
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        // 处理请求错误
        console.error(error);
        throw error;
      });
  },
  //分页查询待审核商铺
  pageStoreApply(data) {
    return api.post('/store/pageStoreApply', data, {
      headers: {
        'Content-Type': 'application/json'
      } // 将传入的headers对象作为请求的headers
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        // 处理请求错误
        console.error(error);
        throw error;
      });
  },
  //开通商铺-查询用户
  StoreAddkey(data) {
    return api.post('/store/openStoreSearch', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //开通商铺
  openStore(data) {
    return api.get('/store/openStore', {
      params: {
        userId: data // 将请求参数传入 params 对象中
      }
    }).then(res => {
      return res.data;
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //店铺详情
  storeInfo(data) {
    return api.get('/store/storeInfo', {
      params: {
        storeId: data
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });

  },
  //分页查询操作日志
  pageLog(data) {
    return api.post('/log/pageLog', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询管理员
  pageAdmin(data) {
    return api.post('/admin/pageAdmin', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //创建管理员
  createAdmin(data) {
    return api.post('/platform/createAdmin', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //助花订单
  pageOrder(data, orderType, orderStatus) {
    return api.post('/order/pageOrder', data, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        orderType: orderType,
        orderStatus: orderStatus
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //树形查询角色权限
  treePerm() {
    return api.post('/adminPerm/treePerm', {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //增删管理角色
  changeRole(data, actionType) {
    return api.post('/adminRole/changeRole', data, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        actionType: actionType
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询管理角色
  pageRole(data) {
    return api.post('/adminRole/pageRole', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //修改管理角色
  alterRole(data) {
    return api.post('/adminRole/alterRole', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });

  },
  //创建管理账号并指定角色列表
  createAdmin(data) {
    return api.post('/admin/createAdmin', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //删除管理账号
  delAdmin(data) {
    return api.get('/admin/delAdmin', {
      params: {
        userId: data
      }
    }, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询轮播图
  pageCarousel(data) {
    return api.post('/carousel/pageCarousel', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //删除轮播图
  removeCarousel(data) {
    return api.post('/carousel/removeCarousel', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //封禁/解封店铺
  changeBanned(storeId, banned) {
    return api.get('/store/changeBanned', {
      params: {
        storeId: storeId,
        bannedStatus: banned
      }
    }, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //查询管理账号详情
  getAdminDetails(data) {
    return api.get('/admin/getAdminDetails', {
      params: {
        adminId: data
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //修改管理账号信息(包含角色列表)
  alterAdmin(data) {
    return api.post('/admin/alterAdmin', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //修改管理账号密码
  alterAdminPwd(data) {
    return api.post('/admin/alterAdminPwd', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //订单发货
  delivery(data) {
    return api.get('/order/delivery', {
      params: data
    }).then(res => {
      return res.data;
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //获取物流公司列表
  getDeliveryCompanyList() {
    return api.get('/order/getDeliveryCompanyList', {

    }).then(res => {
      return res.data;
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //修改申请状态 
  alterAuditStatus(userId) {
    return api.get('/store/alterAuditStatus', {
      params: {
        userId,
        applyStatus: 1
      }
    }).then(res => {
      return res.data;
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //强制标记为已收货
  complete(orderId, orderType) {
    return api.get('/order/complete', {
      params: {
        orderId,
        orderType,
      }
    }).then(res => {
      return res.data;
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //查询管理角色详情
  getRoleDetails(roleId) {
    return api.get('/adminRole/getRoleDetails', {
      params: {
        roleId
      }
    }).then(res => {
      return res.data;
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询秒杀专场
  pageVenue(data) {
    return api.post('/seckillVenue/pageVenue', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //预添加秒杀场次
  preAddVenue(data) {
    return api.post('/seckillProduct/preAddVenue', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  Venuesave(data) {
    return api.post('/seckillVenue/save', data,
    ).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询秒杀商品 
  pageProduct(data, isPassAudit) {
    return api.post('/seckillProduct/pageProduct', data, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        isPassAudit,
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //下架并置为审核失败
  offShelves(data) {
    return api.get('/seckillProduct/offShelves', {
      headers: {
        'Content-Type': 'application/json'
      },
      params: data
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //执行秒杀商品审核
  doAudit(data) {
    return api.post('/seckillProduct/doAudit', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询系统消息
  pageMsg(data, param) {
    return api.post('/msg/pageMsg', data, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: param
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //导出字段到屏幕
  exportEntityType(data) {
    return api.get('/common/exportField2Screen/' + data).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //导出数据到文件
  exportData2File(data) {
    return api.post('/common/exportData2File', data, {
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'arraybuffer'
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  markOverRead(data) {
    return api.post('/msg/markOverRead', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询违禁词
  pageFbword(data) {
    return api.post('/fbword/pageFbword', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询充值记录
  pageRechargeLog(data) {
    return api.post('/funds/pageRechargeLog', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询礼包
  pageGift(data,state) {
    return api.post('/vipGift/pageGift', data, {
      headers: {
        'Content-Type': 'application/json'
      },
      params:{
        state:state,
        storeId:77
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //新增礼包
  addGift(data) {
    return api.get('/vipGift/addGift', {
      headers: {
        'Content-Type': 'application/json'
      },
      params: data
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //删除礼包
  removeGift(data) {
    return api.get('/vipGift/removeGift', {
      headers: {
        'Content-Type': 'application/json'
      },
      params: data
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //修改礼包
  alterGift(data) {
    return api.post('/vipGift/alterGift',data, {
      headers: {
        'Content-Type': 'application/json'
      },
   
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //修改礼包商品数量
  alterProductCount(data) {
    return api.get('/vipGift/alterProductCount', {
      headers: {
        'Content-Type': 'application/json'
      },
      params: data
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //新增礼包商品
  addGiftProduct(data) {
    return api.post('/vipGift/addGiftProduct', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询商品
  pageProductvipGift(data, param) {
    return api.post('/vipGift/pageProduct', data, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: param
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询礼包订单
  pageGiftOrder(data, param) {
    return api.post('/vipGift/pageGiftOrder', data, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: param
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //设置领取备注 礼包订单
  setReceiveRemark(param) {
    return api.get('/vipGift/setReceiveRemark', {
      headers: {
        'Content-Type': 'application/json'
      },
      params: param
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  },
  //分页查询零元购记录
  pageFreebuy(data){
    return api.post('/freebuy/pageFreebuy', data, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(res => {
      return res.data
    }).catch(error => {
      // 处理请求错误
      console.error(error);
      throw error;
    });
  }

};